// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as LbRegionSelect from "./LbRegionSelect.bs.js";
import FormatDistanceToNow from "date-fns/formatDistanceToNow";

function LbTopRow(Props) {
  var region = Props.region;
  var lastUpdated = Props.lastUpdated;
  var setRegion = Props.setRegion;
  var cutoffs = Props.cutoffs;
  return React.createElement("div", {
              className: "max-w-[100vw] flex items-center md:flex-col md:items-start gap-3 justify-between p-2 pb-3"
            }, React.createElement("div", undefined, React.createElement(LbRegionSelect.make, {
                      region: region,
                      setRegion: setRegion
                    })), React.createElement("div", {
                  className: "flex flex-col sm:flex-row gap-1 justify-between items-center w-full"
                }, React.createElement("div", {
                      className: "flex gap-1 text-sm text-white2 pr-2 md:pl-0"
                    }, React.createElement("div", {
                          className: "pr-1"
                        }, "Updated"), React.createElement("div", undefined, FormatDistanceToNow(lastUpdated) + " ago")), cutoffs !== undefined ? React.createElement("div", {
                        className: "flex gap-1 text-sm items-center font-montserrat font-medium mr-2"
                      }, React.createElement("div", {
                            className: "mr-1"
                          }, "Cutoffs"), React.createElement("img", {
                            className: "my-[-2px]",
                            height: "24",
                            src: "https://ap.tft.tools/img/banner/challenger_solo.png?width=24",
                            width: "24"
                          }), React.createElement("div", undefined, String(Belt_Array.getExn(cutoffs, 0)) + "LP"), React.createElement("img", {
                            className: "my-[-2px] ml-1",
                            height: "24",
                            src: "https://ap.tft.tools/img/banner/grandmaster_solo.png?width=24",
                            width: "24"
                          }), React.createElement("div", undefined, String(Belt_Array.getExn(cutoffs, 1)) + "LP")) : null));
}

var make = React.memo(LbTopRow);

export {
  make ,
  
}
/* make Not a pure module */
